"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Brand = _interopRequireDefault(require("./Brand"));
var _link = require("../link");
var _AuthDropdown = _interopRequireDefault(require("./AuthDropdown"));
var _AuthItem = _interopRequireDefault(require("./AuthItem"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * An Authenticated Navbar for MassMutual.com with logout button and setting dropdown on the right.  Hamburger would show on the right on small screen size.
 */
const NavBarAuthenticated = props => {
  const {
    logoSrc,
    logoPath,
    primaryItems,
    iconNav,
    profileItems,
    logoutPath,
    authOnSelect
  } = props;
  const logoText = 'MassMutual Logo';
  const [expanded, setExpanded] = (0, _react.useState)(false);
  const onToggleClick = () => {
    setExpanded(!expanded);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-navbar--auth"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Navbar, {
    collapseOnSelect: true,
    expand: "lg",
    variant: ""
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Navbar.Brand, {
    id: "auth_nav_mm-home",
    href: (0, _link.absolute)({
      url: logoPath
    })
  }, /*#__PURE__*/_react.default.createElement(_Brand.default, {
    logoSrc: logoSrc,
    logoText: logoText
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Navbar.Toggle, {
    "aria-controls": "responsive-navbar-nav",
    "aria-expanded": expanded,
    onClick: onToggleClick
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Navbar.Collapse, {
    id: "responsive-navbar-nav"
  }, primaryItems?.length > 0 && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav, null, primaryItems.map((item, index) => /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav.Item, {
    key: item.title
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav.Link, {
    eventKey: index,
    href: item.path,
    id: `auth_nav_${item.slug}`
  }, /*#__PURE__*/_react.default.createElement("span", null, item.title))))), !profileItems && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav, null, iconNav.map((item, index) => {
    if (item.dropdownContent?.length > 0) {
      return /*#__PURE__*/_react.default.createElement(_AuthDropdown.default, {
        item: item,
        key: index
      });
    } else {
      return /*#__PURE__*/_react.default.createElement(_AuthItem.default, {
        item: item,
        key: index
      });
    }
  })), profileItems && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav, null, profileItems?.length > 0 && /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown, {
    title: "Settings",
    id: "collasible-nav-dropdown",
    className: "settings"
  }, profileItems.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown.Item, {
      eventKey: index,
      href: item.path,
      id: `auth_nav_${item.slug}`,
      key: item.slug
    }, /*#__PURE__*/_react.default.createElement("span", null, item.title));
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav.Item, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav.Link, {
    className: "logout",
    eventKey: "1",
    href: logoutPath,
    id: "auth_nav_logout",
    key: "Logout",
    onSelect: authOnSelect
  }, /*#__PURE__*/_react.default.createElement("span", null, "Log Out"))))))));
};
NavBarAuthenticated.propTypes = {
  /**
   * The MassMutual logo. The default uses a logo in Blueprint-CSS, but can be overridden with a URL to your own logo.
   */
  logoSrc: _propTypes.default.string,
  /**
   * The MassMutual logo URL HREF. Where does a user navigate when clicking on the logo?
   */
  logoPath: _propTypes.default.string,
  /**
   * Items links on the nav bar.
   */
  primaryItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    path: _propTypes.default.string,
    slug: _propTypes.default.string
  })),
  /**
   * Configurable right side of nav bar:
   - Limited icons available: `help`, `notification`, `settings`, `switch-portal`, `user`, and `logout`
   - Text next to icon can be hidden by setting `iconOnly` to true
   - Items can be a link or dropdown
   */
  iconNav: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    path: _propTypes.default.string,
    slug: _propTypes.default.string,
    iconOnly: _propTypes.default.bool,
    iconClass: _propTypes.default.string,
    hasNotice: _propTypes.default.bool,
    hasPhoto: _propTypes.default.bool,
    photoUrl: _propTypes.default.string,
    dropdownRight: _propTypes.default.bool,
    dropdownContent: _propTypes.default.arrayOf(_propTypes.default.shape({
      title: _propTypes.default.string,
      path: _propTypes.default.string,
      slug: _propTypes.default.string
    }))
  })),
  logoutPath: _propTypes.default.string,
  /**
   * Callback function to invoke when Logout was clicked.
   */
  authOnSelect: _propTypes.default.func,
  /**
   * Deprecated pattern for links in the setting menu.
   */
  profileItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    path: _propTypes.default.string,
    slug: _propTypes.default.string
  }))
};
NavBarAuthenticated.defaultProps = {
  logoSrc: 'default',
  logoPath: '#',
  logoutPath: '#',
  primaryItems: [{
    title: 'Item 1',
    path: 'https://www.massmutual.com/',
    slug: 'homepage-site-header-item-1'
  }, {
    title: 'Item 2',
    path: 'https://www.massmutual.com/',
    slug: 'homepage-site-header-item-2'
  }, {
    title: 'Item 3',
    path: 'https://www.massmutual.com/',
    slug: 'homepage-site-header-item-3'
  }],
  iconNav: [{
    title: 'Notifications',
    path: 'https://www-dev.massmutual.com/dashboard/sampleLink',
    slug: 'homepage-site-header-notifications',
    iconOnly: true,
    iconClass: 'notification',
    hasNotice: true
  }, {
    title: 'Help',
    path: 'https://www-dev.massmutual.com/dashboard/sampleLink',
    slug: 'homepage-site-header-help',
    iconOnly: true,
    iconClass: 'help'
  }, {
    title: 'Settings',
    slug: 'homepage-site-header-settings',
    iconOnly: true,
    iconClass: 'settings',
    dropdownContent: [{
      title: 'Login Settings',
      path: 'https://www.massmutual.com/',
      slug: 'homepage-site-header-loginSettings'
    }, {
      title: 'Account Settings',
      path: 'https://www.massmutual.com/',
      slug: 'homepage-site-header-acctSettings'
    }]
  }, {
    title: 'Switch Portal',
    slug: 'homepage-site-header-switch-portal',
    iconOnly: true,
    iconClass: 'switch-portal',
    dropdownContent: [{
      title: 'Link 1',
      path: 'https://www.massmutual.com/',
      slug: 'homepage-site-header-link-1'
    }, {
      title: 'Link 2',
      path: 'https://www.massmutual.com/',
      slug: 'homepage-site-header-link-2'
    }]
  }, {
    title: 'User',
    slug: 'homepage-site-header-user',
    iconOnly: true,
    iconClass: 'user',
    dropdownRight: true,
    iconUrl: './blueprint-css/mm-consumer/images/icons/display/user.svg',
    // photoUrl:
    //   'https://i.natgeofe.com/n/4f5aaece-3300-41a4-b2a8-ed2708a0a27c/domestic-dog_thumb.jpg',
    dropdownContent: [{
      title: 'Sample Link 1',
      path: 'https://www.massmutual.com/',
      slug: 'homepage-site-header-link-1'
    }, {
      title: 'Sample Link 2',
      path: 'https://www.massmutual.com/',
      slug: 'homepage-site-header-link-2'
    }]
  }, {
    title: 'Log Out',
    path: 'https://www-dev.massmutual.com/dashboard/sampleLink',
    slug: 'homepage-site-header-logout',
    iconOnly: true,
    iconClass: 'logout'
  }]
};
var _default = exports.default = NavBarAuthenticated;